var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBjWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 24 18",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF00",
    d: "m11.476 5.49-3.161 5.567a.604.604 0 0 1-.88.19L3.322 8.25a.604.604 0 0 0-.938.643l1.998 7.504a.79.79 0 0 0 .766.589h13.7c.36 0 .674-.242.766-.59l1.995-7.503a.604.604 0 0 0-.938-.642l-4.108 2.994a.604.604 0 0 1-.88-.19L12.526 5.49a.604.604 0 0 0-1.05 0m.523-1.455c.785 0 1.422-.586 1.422-1.309S12.784 1.417 12 1.417c-.786 0-1.423.586-1.423 1.31 0 .722.637 1.308 1.423 1.308M2.03 7.157c.791 0 1.432-.588 1.432-1.313 0-.726-.641-1.313-1.431-1.313S.6 5.119.6 5.844s.64 1.313 1.43 1.313m19.943-.002c.788 0 1.427-.586 1.427-1.31 0-.722-.639-1.308-1.427-1.308s-1.426.586-1.426 1.309.638 1.309 1.426 1.309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBjWin);
export default __webpack_public_path__ + "static/media/IcoBJWin.2821f0de129c7726ea684a95f53c8114.svg";
export { ForwardRef as ReactComponent };